module.exports = __webpack_public_path__ + "static/media/912345_10151669993068273_108204272_n.b9c88b18.jpg";